export const MUTATION_TYPES = {
  SET_ACADEMICYEARS: 'SetAcademicYears',
  SET_SERVICESTATUS: 'SetServiceStatus',
  SET_SERVICETYPES: 'SetServiceTypes',
  SET_RESULTS_FILTERED: 'SetResults',
  SET_REASONS: 'SetReasons',
  SET_CURRENT_FILTERS: 'setCurrentFilters',
  SET_SHOW_NOTIFICATION: 'SetShowNotification',
};
//actions Think is need to do this? (Only if is calling )
export const ACTION_TYPES = {
  GET_FILTERS: 'GetFilters',
  GET_RESULTS_FILTERED: 'GetResultsFiltered',
  GET_REASONS_BY_ACTION_ID: 'getReasonsByActionId',
  SAVE_DETERMINATION: 'SaveDetermination',
};
